const FuzzyReaction = require('../bootstrap').FuzzyReaction;
const AppDispatcher = FuzzyReaction.Dispatcher;
const AppActionConstants = require('../constants/AppActionConstants');
const assign = require('object-assign');
const ModelStore = FuzzyReaction.Stores.ModelStore;

/**
 * Data stores
 * @type {Array}
 * @private
 */
let _resourceListData = [];

/**
 * User store logic
 *
 * @type {*|exports}
 */
const FormatModalitiesStore = assign({}, ModelStore, {
    getResourceListData: function () {
        return _resourceListData;
    }
});

/**
 * Event Listeners
 */
FormatModalitiesStore.dispatchToken = AppDispatcher.register(function (action) {
    switch (action.type) {
        case 'FORMAT-MODALITIES_LISTED':
            _resourceListData = action.data;

            FormatModalitiesStore.emitChange();
            break;
    }
});

module.exports = FormatModalitiesStore;
